import { DataPointCommissioningCheckType } from '@serodigital/ies-api-client';
import { Icons, Tooltip, Text } from '@serodigital/ui-components';
import { DateTime } from 'luxon';
import * as React from 'react';
import { BeeStatus } from '../../../../../shared/api-clients/_api';

type IDataPointCheckProps = {
  data: string;
  canViewPeripheralData: boolean;
  onlineStatus: string;
  datapoint_checks: DataPointCommissioningCheckType[];
  setIsModalOpen: (value: boolean) => void;
  setData: (value: string) => void;
};

export function DatapointCheck({
  data,
  canViewPeripheralData,
  onlineStatus,
  datapoint_checks,
  setIsModalOpen,
  setData,
}: IDataPointCheckProps) {
  return (
    <>
      <div className='flex justify-between w-full'>
        <div className='flex flex-1 flex-col'>
          <span className='text-[#575756] text-small font-bold'>Peripheral Data Range Checks:</span>
          {data && JSON.parse(data)?.timestamp && (
            <span className='text-[#575756] text-small'>
              Last updated :{' '}
              {DateTime.fromISO(JSON.parse(data || JSON.stringify({}))?.timestamp).toFormat("ccc d LLLL 'at' t")}
            </span>
          )}
        </div>
        {canViewPeripheralData && (
          <div className='flex flex-1 justify-end'>
            <button
              data-qa='view-packet-data-button'
              className={`text-[#575756] text-small ${
                data === null || onlineStatus === BeeStatus.Offline ? 'opacity-20 pointer-events-none' : ''
              }`}
              onClick={() => {
                if (data === null || onlineStatus === BeeStatus.Offline) return;
                setIsModalOpen(true);
                setData(data);
              }}
            >
              View Packet Data
            </button>
          </div>
        )}
      </div>
      <div className='flex flex-row flex-wrap mt-16'>
        {datapoint_checks?.map((check) => {
          return (
            <StatusTooltip status={check.status}>
              <div className="flex items-center mr-16">
                <span className='text-small'>{determineIconToUseForDatapointCheck(check.status, onlineStatus)} </span>
                <p className='text-small ml-4'>{formatPeripheralDataPointCheckName(check.name)}</p>
              </div>
            </StatusTooltip>
          );
        })}
      </div>
    </>
  );
}

const StatusTooltip = ({ children, status }: { children: React.ReactElement; status: string }) => {
  return (
    <Tooltip
      TooltipComponent={() => <p>{formatPeripheralDataPointCheckName(status)}</p>}
      hasArrow
      placement="top"
      showOnHover
      data-qa={`peripheral-data-tooltip-status-${status}`}
    >
      {children}
    </Tooltip>
  );
};

const determineIconToUseForDatapointCheck = (status: string, onlineStatus: string) => {
  if (onlineStatus === BeeStatus.Offline) {
    return <Icons.RedCrossNoBackground className='mt-12 dpcheck' />;
  }

  switch (status) {
    case 'failed':
      return <Icons.ExclamationMark className='mt-12 dpcheck' />;
    case 'no_mapping':
      return <Icons.QuestionMark className='mt-12 dpcheck' />;
    case 'no_data':
      return <Icons.RedCrossNoBackground className='mt-12 dpcheck' />;
    default:
      return <Icons.GreenTickNoBackground className='mt-12 dpcheck' />;
  }
};

const formatPeripheralDataPointCheckName = (name: string) => {
  const words = name.split('_');

  return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
